/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PaymentStatus {
    FAILED = 'failed',
    SUCCESS = 'success',
    PENDING = 'pending',
}
